import { makeAutoObservable } from 'mobx';
// import { RootStore } from 'mobx-stores/root-store'
import { ReviewDTO } from 'models/review'

export class OrdersDetailsStore {
  private rootStore: any

  constructor (rootStore: any) {
    this.rootStore = rootStore
    makeAutoObservable(this);
  }

  // OBSERVABLES
  private orderDetailsVisible: boolean = null;
  private orderDetails = null;

  // ACTIONS
  public setOrderDetails = (visible: boolean, orderId?: number | string): void => {
    if(visible) {
      this.getSingleStoreById(orderId);
      return
    }
    this.orderDetailsVisible = visible;
  }

  // COMPUTED
  public get isOrderDetailsVisible(): boolean {
    return this.orderDetailsVisible;
  }

  public get statusOrderDetails() {
    return this.orderDetails;
  }

  // METHODS
  public getSingleStoreById = async (orderId: number | string) => {
    const orderInfo = await this.rootStore.generalStore.api.storeApi.getOrderById(
      orderId
    )
    if(!orderInfo) return;
    this.orderDetails = orderInfo
    this.orderDetailsVisible = true;
  }

  public rateStoreProduct = async (payloadStars: Partial<ReviewDTO>) => {
    this.rootStore.generalStore.api.reviewsApi.setStoreProductReviews(
        payloadStars
    )
  }

}
